export default [
  {
    name: 'FunnelsManagementCompaniesList',
    path: 'settings/companies/funnels-management',
    component: () => import('pages/settings/funnels-management/FunnelsManagementCompaniesList.vue')
  },
  {
    name: 'FunnelsManagementList',
    path: 'settings/companies/:id/funnels-management',
    component: () => import('pages/settings/funnels-management/FunnelsManagementList.vue')
  },
  {
    name: 'FunnelsManagementCreate',
    path: 'settings/companies/:id/funnels-management/new',
    component: () => import('pages/settings/funnels-management/FunnelsManagementForm.vue')
  },
  {
    name: 'FunnelsManagementSingle',
    path: 'settings/companies/:id/funnels-management/:funnelManagementId',

    component: () => import('pages/settings/funnels-management/FunnelsManagementSingle.vue')
  },
  {
    name: 'FunnelsManagementEdit',
    path: 'settings/companies/:id/funnels-management/:funnelManagementId/edit',
    component: () => import('pages/settings/funnels-management/FunnelsManagementForm.vue')
  }
]
